//Please add the language resource
const assign = {
  assignCode:'assignCode',
  assignName:'assignName',
  proviceName: 'ProviceName',
  cityName: 'CityName',
  addr:'Addr',
  assignTypeCode:'assignTypeCode',
  assignTypeName:'assignTypeName',
  contact:'Contact',
  tel:'Tel',
  email: 'Email',
  createTime:'CreateTime',
  creator:'Creator',
  updateTime:'UpdateTime',
  updater:'Updater',
  msg:{
  }
};
export default assign



// WEBPACK FOOTER //
// ./src/page/order/assign/lang/assign.en.js